module.exports = __webpack_public_path__ + "static/bootstrap-card-horizontal-00d8205ee2243eff406deb4e015609c9.png";